<div class="req-content">

  @if (costs.length>0) {
    <div class="table-container mat-elevation-z8">
      <table class="table table-striped border_bottom table-hover table-sm">
        <thead>
          <tr>
            <th scope="col" class="border-top-0">Descripción</th>
            <th scope="col" class="border-top-0">Cantidad</th>
            <th scope="col" class="border-top-0">Tipo</th>
            <th scope="col" class="border-top-0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (row of costs; track row; let i = $index) {
            <tr data-toggle="collapse" data-target=".order1">
              <td>
                {{ row.name}}
              </td>
              <td>{{ row.amount || '0' | currencyPipe }} {{row.currency}}</td>
              @if (row.typeEntity == typeEntity.costs) {
                <td>
                  {{getLabelById(row.type, listTypeCosts)}}
                </td>
              }
              @if (row.typeEntity == typeEntity.fee) {
                <td>
                  {{getLabelById(row.type, listTypeFee)}}
                </td>
              }
              <td>
                <div class="dropdown">
                  <div ngbDropdown [open]="false" [autoClose]="true" class="d-inline-block">
                    <i id="dropdownBasic1" class="fas fa-ellipsis-v" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false" dropdown-menu dropdown-menu-left show
                    ngbDropdownToggle (click)="$event.stopPropagation();" style="cursor: pointer;"></i>
                    <div class="dropdown-menu" ngbDropdownMenu="dropdownBasic1">
                      <a class="dropdown-item icon-table" style="cursor: pointer;"
                        (click)="openModalToEdit(row)">
                        <i class="far fa-eye"></i>
                        Editar
                      </a>
                      <a class="dropdown-item icon-table" (click)="openModalToDeleteCost(row.id)"
                        style="cursor: pointer;">
                        <i class="far fa-trash-alt"></i>
                        Eliminar
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>